import React from "react";

import { getMessage } from "CONFIG/i18n";

import ic_switch_on from "ASSETS/Images/ic_switch_on.svg";
import ic_switch_off from "ASSETS/Images/ic_switch_off.svg";

const Switch = (props) => {

  return (
    <div className={props.disabled ? "cursorDisabled" : "cursorPointer"}>
      {props.switchOn ? <img
        src={ic_switch_on}
        onClick={() =>props.toggleSwitch(false)}
      />:<img
        data-toggle="tooltip"
        data-placement="top"
        title={getMessage("ALLOW_EDIT")}
        src={ic_switch_off}
        onClick={() =>props.toggleSwitch(true)}
      />}
    </div>
  );
}

export default Switch;